import React from "react";
import { Box, Heading, SimpleGrid, Text, Icon, Image } from "@chakra-ui/react";

const services = [
  {
    icon: "asset/product-icon.png",
    title: "Product Design",
    description:
      "I design digital products that connect customer needs with business goals in a meaningful way.",
  },
  {
    icon: "asset/graphic-icon.png",
    title: "UI/UX Design",
    description:
      "Designing user interfaces and experiences that are both functional and visually appealing.",
  },
  {
    icon: "asset/web-icon.png",
    title: "Mobile App Development",
    description:
      "Developing cross-platform mobile applications for iOS and Android.",
  },
];

const Services = () => {
  return (
    <Box py={10} px={5} id="services" mt="40px">
      <Heading
        as="h2"
        fontSize={{ base: "2xl", md: "3xl", lg: "4xl" }}
        mb="8"
        textAlign={{ base: "center", md: "left" }}
      >
        Services
      </Heading>
      <Text mb={4}>
        If you’re a startup looking for a designer with a broad skill set from
        concept and strategy to design and prototyping, get in touch.
      </Text>
      <SimpleGrid columns={{ base: 1, md: 2, lg: 3 }} spacing={10}>
        {services.map((service, index) => (
          <ServiceCard key={index} {...service} />
        ))}
      </SimpleGrid>
    </Box>
  );
};
const ServiceCard = ({ icon, title, description }) => {
  return (
    <Box
      p={8}
      backgroundColor="#753376"
      borderRadius="lg"
      overflow="hidden"
      boxShadow="lg"
      textAlign="left"
      height="100%"
      _hover={{
        boxShadow: "lg",
        backgroundColor: "#FF15F5",
        color: "#fff",
        transform: "scale(1.03)",
        transition: "all 0.3s ease",
      }}
    >
      <Image src={icon} w={10} h={10} mb={4} color="#fff" />
      <Text fontWeight="bold" fontSize="xl" mb={2} color="#fff">
        {title}
      </Text>
      <Text color="#fff" fontSize="lg">
        {description}
      </Text>
    </Box>
  );
};

export default Services;
